import styled from 'styled-components';
import { Body4 } from './../../../common/typography';

export const SubTitleDepartment = styled.div``;

export const SubTitleSection = styled(Body4)`
  display: inline;
  margin-left: ${({ theme }) => theme.spacing.xs};
`;
